module.exports = __webpack_public_path__ + "static/media/telegram2.677a7e2e.png";